/**
 * Utility functions for converting between WhatsApp Business API template names
 * and user-friendly display names
 */

/**
 * Convert WAB format (lowercase_with_underscores) to Title Case (First Letter Caps)
 * Example: "hello_world_template" -> "Hello World Template"
 */
export function formatTemplateNameForDisplay(wabName: string): string {
    if (!wabName) return '';

    return wabName
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

/**
 * Convert user input to WAB format (lowercase with underscores)
 * Example: "Hello World Template" -> "hello_world_template"
 */
export function formatTemplateNameForAPI(displayName: string): string {
    if (!displayName) return '';

    return displayName
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_'); // Replace one or more spaces with underscore
}

/**
 * Validate template name input - only letters, numbers, and spaces allowed
 */
export function isValidTemplateNameInput(input: string): boolean {
    return /^[a-zA-Z0-9\s]*$/.test(input);
}
